import React from "react";
import { Radio, RadioGroup } from "@skbkontur/react-ui";
import { Dropdown, MenuItem } from "react-ui";

import { ImportEmployerDocumentsFilter, ImportEmployerDocumentsFilterType } from "../../../EmployeeServiceTypes";
import { getFilterSelectValue } from "../../State/EmployerDocumentsStateUtils";

import { FiltersCol, FiltersHint, FiltersRow, FilterTitle } from "./EmployerDocumentsFilter.styles";

export interface EmployerDocumentsFilterProps {
    filterOptions: ImportEmployerDocumentsFilter;
    selectedFilterType: ImportEmployerDocumentsFilterType;
    selectedFilterValue?: string | number;
    onChangeFilterValue: (filterValue: string | number) => void;
    onChangeFilterType: (filterType: ImportEmployerDocumentsFilterType) => void;
}

const filterTypeTitle: Record<ImportEmployerDocumentsFilterType, string> = {
    [ImportEmployerDocumentsFilterType.Month]: "Помесячно",
    [ImportEmployerDocumentsFilterType.Quarter]: "Поквартально",
};
const filterValueSelectTitle: Record<ImportEmployerDocumentsFilterType, string> = {
    [ImportEmployerDocumentsFilterType.Month]: "Месяц для заполнения",
    [ImportEmployerDocumentsFilterType.Quarter]: "Квартал для заполнения",
};

export const EmployerDocumentsFilter = (props: EmployerDocumentsFilterProps): JSX.Element => {
    const filterSelectValue = getFilterSelectValue(
        props.selectedFilterValue,
        props.filterOptions.selectValues[props.selectedFilterType]
    );

    const hideDropdown = props.filterOptions.hideFilterSelectFor?.includes(props.selectedFilterType) ?? false;

    return (
        <div>
            <FiltersRow>
                <FiltersCol size={1}>
                    <FilterTitle>Как заполнить</FilterTitle>
                </FiltersCol>
                <FiltersCol size={2}>
                    <div>
                        <RadioGroup value={props.selectedFilterType}>
                            {props.filterOptions.filterTypes.map(it => (
                                <div key={it}>
                                    <Radio
                                        value={it}
                                        onValueChange={value => {
                                            props.onChangeFilterType(value);
                                        }}>
                                        {filterTypeTitle[it] ?? it}
                                    </Radio>
                                </div>
                            ))}
                        </RadioGroup>
                    </div>
                </FiltersCol>
            </FiltersRow>
            {!hideDropdown && (
                <FiltersRow>
                    <FiltersCol size={1}>
                        <FilterTitle>
                            {filterValueSelectTitle[props.selectedFilterType] ?? props.selectedFilterType}
                        </FilterTitle>
                    </FiltersCol>
                    <FiltersCol size={1}>
                        <Dropdown caption={filterSelectValue?.label} width={140}>
                            {props.filterOptions.selectValues[props.selectedFilterType].map(it => (
                                <MenuItem
                                    key={it.value}
                                    onClick={() => {
                                        props.onChangeFilterValue(it.value);
                                    }}>
                                    {it.label}
                                </MenuItem>
                            ))}
                        </Dropdown>
                    </FiltersCol>
                    <FiltersCol size={1}>
                        <FiltersHint>Период черновика, в&nbsp;котором заполняются данные</FiltersHint>
                    </FiltersCol>
                </FiltersRow>
            )}
        </div>
    );
};
